import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClapIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 108,
	height: 108,
	fill: "none",
	viewBox: "0 0 108 108",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		transform: "translate(-195)",
		clipPath: "url(#clip0_1959_28657)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				fill: "#acd4ff",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m274.523 16.875c1.748 0 3.164-1.4167 3.164-3.1641v-10.5468c0-1.74741-1.416-3.16406-3.164-3.16406-1.747 0-3.164 1.41665-3.164 3.16406v10.5468c0 1.7474 1.417 3.1641 3.164 3.1641z" }),
					/* @__PURE__ */ _jsx("path", { d: "m292.505 14.9695 7.459-7.45876c1.235-1.23567 1.235-3.23894 0-4.47461-1.236-1.23567-3.239-1.23567-4.475 0l-7.459 7.45877c-1.235 1.2356-1.235 3.2389 0 4.4746 1.236 1.2357 3.239 1.2357 4.475 0z" }),
					/* @__PURE__ */ _jsx("path", { d: "m299.836 25.3125h-10.547c-1.747 0-3.164 1.4167-3.164 3.1641s1.417 3.164 3.164 3.164h10.547c1.747 0 3.164-1.4166 3.164-3.164s-1.417-3.1641-3.164-3.1641z" })
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m231.425 37.5125 16.73-16.7299c1.78-1.7799 3.972-2.997 6.36-3.5674-0.227-0.3179-0.481-0.622-0.766-0.9074-2.78-2.7802-7.288-2.7802-10.068 0l-13.562 13.5616c1.181 2.3595 1.637 4.9979 1.306 7.6431z",
				fill: "#002e5f"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m204.701 33.1369c1.068-5.2319 5.14-9.2585 10.179-10.4188-1.077-1.4891-2.765-2.5621-4.716-2.853-3.799-0.6699-7.441 1.808-8.212 5.5878l-6.502 31.8661c-1.056 5.1745-0.229 10.45 2.215 14.9617-0.132-2.4074 0.039-4.8511 0.534-7.2777z",
				fill: "#002e5f"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m252.629 25.257-26.239 26.2396c-1.462 1.4616-3.935 0.1668-3.567-1.867l2.261-12.5017c0.702-3.881-1.885-7.5933-5.769-8.2782-3.848-0.7895-7.633 1.6974-8.413 5.5521l-6.502 31.8661c-1.491 7.3064 0.767 14.8164 6.04 20.0892l15.155 15.1559c8.65 8.649 22.673 8.649 31.323 0l33-33.001c2.78-2.7801 2.78-7.2878 0-10.068s-7.287-2.7802-10.068 0l2.983-2.9831c2.78-2.7801 2.78-7.2879 0-10.068-2.78-2.7802-7.287-2.7802-10.068 0l4.475-4.4746c2.78-2.7802 2.78-7.2879 0-10.0681-2.78-2.7801-7.288-2.7801-10.068 0l-4.475 4.4746c2.78-2.7801 2.78-7.2876 0-10.068-2.78-2.7799-7.287-2.7799-10.068 2e-4z",
				fill: "#006adc"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1959_28657",
		children: /* @__PURE__ */ _jsx("rect", {
			transform: "translate(195)",
			width: 108,
			height: 108,
			fill: "#fff"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgClapIcon);
export default ForwardRef;
